enum PoOrderBy {
    CREATED_AT = "created_at",
    UPDATED_AT = "updated_at",
    NAME = "name",
    VENDOR_SOURCE_NAME = "Vendor_Source.name",
    ORDER_NAME = "Order.name",
    PO_STATE_ID = "purchase_order_state_id",
}

export default PoOrderBy;
